import { render, staticRenderFns } from "./ActiveDashlet.vue?vue&type=template&id=68b48990"
import script from "./ActiveDashlet.vue?vue&type=script&lang=js"
export * from "./ActiveDashlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports